import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import store from './global/store';

import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';

const palette = {
  type: 'light',
  primary: {
    main: '#00ADEE',
    contrastText: '#fff'
  },
  success: {
    main: '#6CB33F',
    contrastText: '#fff',
    light: '#A9FF73',
    dark: '#5C9936',
    lighter: '#E7FFD9',
  },
  error: {
    main: '#FF0000',
    contrastText: '#fff'
  },
  text: {
    primary: '#585858',
    contrastText: '#fff'
  },
  background: {
    default: '#ffffff'
  },
  vacant: {
    main: '#003C73',
    contrastText: '#fff'
  },
  assigned: {
    main: '#6cb33f',
    contrastText: '#fff'
  },
  reserved: {
    main: '#ecab00',
    contrastText: '#fff'
  },
  fault: {
    main: '#ff0000',
    contrastText: '#fff'
  }
};

const theme = createMuiTheme({
  palette: palette,
  typography: {
    fontSize: 14,
    h1: {
      fontSize: '3.2rem'
    },
    h2: {
      fontSize: '2.6rem'
    },
    h3: {
      fontSize: '2rem'
    },
    h4: {
      fontSize: '1.8rem'
    },
    h5: {
      fontSize: '1.4rem',
      fontWeight: 300
    },
    h6: {
      fontSize: '1.2rem'
    }
  },
  overrides: {
    MuiButton: {
      root: {
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8
      },
      label: {
        textTransform: 'none'
      },
      containedSizeLarge: {
        padding: '12px 22px',
        fontSize: '1rem'
      },
      contained: {
        backgroundColor: palette.text.primary,
        color: palette.text.contrastText,
        padding: '6px 22px',
        '&:hover': {
          backgroundColor: '#787878',
          color: palette.text.contrastText,
        },
      }
    },
    MuiInputBase: {
      root: {
        borderBottomColor: 'transparent'
      }
    },
    MuiFilledInput: {
      root: {
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8
      }
    },
    MuiSlider: {
      thumb: {
        color: palette.primary.contrastText,
        border: `2px solid ${palette.primary.main}`
      }
    },
    MuiTableCell: {
      head: {
        backgroundColor: palette.text.primary,
        color: palette.primary.contrastText
      }
    },
    MuiTableSortLabel: {
      root: {
        color: palette.primary.contrastText,
        '&$hover': {
          color: palette.primary.contrastText,
        },
        '&$active': {
          color: palette.primary.contrastText,
          '&& $icon': {
            color: palette.primary.contrastText,
          },
        },
        '&& $icon': {
          color: palette.primary.contrastText,
        },
      }
    }
  },
  props: {
    MuiFilledInput: {
      disableUnderline: true
    },
    MuiLink: {
      color: 'textPrimary'
    }
  }
})

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
